/**
 * Set prop & nested prop of object to default value
 * @param {Object} obj
 */
export function clearObject(obj) {
  for (const prop of Object.keys(obj)) {
    if (Array.isArray(obj[prop])) {
      obj[prop] = [];
    } else if (obj[prop] instanceof Object) {
      clearObject(obj[prop]);
    } else if (obj[prop] instanceof String) {
      obj[prop] = "";
    } else if (obj[prop] instanceof Number) {
      obj[prop] = 0;
    } else if (obj[prop] instanceof Boolean) {
      obj[prop] = false;
    } else {
      obj[prop] = undefined;
    }
  }
}

export function toDictionary(items) {
  const dict = {};

  for (let i = 0, len = items.length; i < len; i++) {
    dict[items[i].id] = items[i];
  }

  return dict;
}
